export default{sources:{avif:"__VITE_ASSET__qE8_MRbs__ 400w",webp:"__VITE_ASSET__CUaL22UB__ 400w"},img:{src:"__VITE_ASSET__DFeyqcbt__",w:400,h:267}};